import React from "react";
import { Modal, Form, Input, Row, Col, Card, Button, Switch } from "antd";
import { EtapeService } from "../../services/EtapeService";
import Toast from "../../helpers/Toast";
import { useNavigate } from "react-router-dom";
import PropTypes from "prop-types";
import { catchError } from "../../services/DaoService";
import CustomFormItem from "../utils/form/CustomFormItem";
import style from "./EtapeCreateForm.module.scss";

const EtapeCreateForm = ({ visible, onCreate, onCancel }) => {
  const navigate = useNavigate();
  const [form] = Form.useForm();
  const [creating, setCreating] = React.useState(false);
  const [validationErrors, setValidationErrors] = React.useState({});

  const handleSave = (isRedirection) => {
    setCreating(true);
    form
      .validateFields()
      .then((values) => {
        EtapeService.getInstance()
          .create(values)
          .then((response) => {
            Toast.success(response.message);
            form.resetFields();
            onCreate(response.data);
            if (isRedirection) {
              navigate(`/etape/${response.data.uid}`);
            }
          })
          .catch((error) => {
            const errors = error.response.data;
            if (errors.validation && Object.keys(errors?.errors).length) {
              setValidationErrors(errors.errors);
            } else {
              catchError(error);
            }
          })
          .finally(() => {
            setCreating(false);
          });
      })
      .catch(() => {
        setCreating(false);
      });
  };

  return (
    <Modal
      width={"50%"}
      open={visible}
      onCancel={onCancel}
      title="Créer une nouvelle étape"
      footer={[
        <>
          <Row gutter={24}>
            <Col>
              <Button
                key="cancel"
                onClick={onCancel}
                className={style.ButtonNew}
              >
                Annuler
              </Button>
            </Col>
            <Col>
              <Button
                key="save-again"
                type="primary"
                loading={creating}
                onClick={() => handleSave(false)}
                className={style.ButtonNew}
              >
                Enregistrer et Créer
              </Button>
            </Col>
          </Row>
        </>
      ]}
    >
      <Card style={{ marginBottom: 5 }}>
        <Form
          layout="vertical"
          form={form}
          name="createEtapeForm"
          initialValues={{
            enabled: 1,
          }}
        >
          <Row gutter={24}>
            <Col xs={24} md={24} lg={12}>
              <CustomFormItem
                label="Nom"
                name="nom"
                rules={[{ required: true, message: "Veuillez saisir le nom!" }]}
                validationErrors={validationErrors}
                setValidationErrors={setValidationErrors}
              >
                <Input type="text" />
              </CustomFormItem>
            </Col>
          </Row>

          <Row gutter={24}>
            <Col xs={24} md={24} lg={24}>
              <CustomFormItem
                label="Description"
                name="description"
                validationErrors={validationErrors}
                setValidationErrors={setValidationErrors}
              >
                <Input.TextArea rows={4} />
              </CustomFormItem>
            </Col>
            <Col xs={24} md={24} lg={12}>
              <CustomFormItem
                label="Statut"
                name="enabled"
                rules={[{ required: true, message: "Veuillez saisir le statut !" }]}
                validationErrors={validationErrors}
                setValidationErrors={setValidationErrors}
                valuePropName="checked"
              >
                <Switch />
              </CustomFormItem>
            </Col>
          </Row>

        </Form>
      </Card>
    </Modal>
  );
};

export default EtapeCreateForm;

EtapeCreateForm.propTypes = {
  visible: PropTypes.bool,
  onCreate: PropTypes.func,
  onCancel: PropTypes.func
};
